import React from "react";
import "./Login.css";
import Header from "../Components/Header";
import Feature from "../Components/Feature";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom"; //Link

export default function Login() {
  return (
    <>
      <Header mode="dark" />

      <div className="container-fluid">
          <div className="login-wrapper d-flex align-items-center justify-content-center">
            <form className="login-card text-center">
              <h3 className="login-title">Login to Your Account</h3>

              <input
                type="email"
                className="form-control login-input"
                placeholder="Email Address"
              />

              <input
                type="number"
                className="form-control login-input"
                placeholder="Phone Number"
              />

              <div className="d-flex justify-content-between align-items-center login-options">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" />
                  <label className="form-check-label">Remember Me</label>
                </div>

                <Link to="/forgetpassword" className="forgot-link"> 
                  Forgot password?
               </Link>
              </div>

              <button className="btn login-btn w-100">
                 <Link to="/dashboard">Login</Link>
                </button>

              <p className="register-text">Dont have an account?</p>

            <Link to="/register">
              <p className="register-link">Register Now</p>
            </Link>
            
            </form>
          </div>
        </div>
      <Feature />
      <Footer />
    </>
  );
}
